export const colors = { primary: "bg-[#02497f]" };

export const snackBarColors = {
  success: "success",
  error: "error",
  warning: "warning",
  info: "info",
};
